import { Tag } from 'antd';
import styled from 'styled-components';

export const PriceBadge = ({ size = 'md', variant = 'neutral', children, ...props }) => {
    return (
        <StyledPriceBadge data-size={size} data-variant={variant} {...props}>
            {children}
        </StyledPriceBadge>
    );
};

const StyledPriceBadge = styled(Tag)`
    display: inline-block;
    padding: 4px 12px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 400;
    background: #E8EDF2 !important;
    color: #5E5E5E !important;
    font-family: var(--font-family-lufga);
    text-align: center;
    min-width: 80px;
    box-sizing: border-box;
    border: none !important;
    margin: 0 !important;

    &[data-size='sm'] {
        padding: 2px 8px;
        font-size: 12px;
        min-width: 58px;
        border-radius: 7px;
    }

    &[data-variant='basic'] {
        background: rgba(59, 130, 246, 0.12) !important;
        color: #2563EB !important;
    }

    &[data-variant='pro'] {
        background: rgba(139, 92, 246, 0.14) !important;
        color: #7C3AED !important;
    }

    &[data-variant='premium'] {
        background: rgba(245, 158, 11, 0.16) !important;
        color: #B45309 !important;
    }

    &[data-variant='neutral'] {
        background: #E8EDF2 !important;
        color: #5E5E5E !important;
    }

    @media (max-width: 768px) {
        font-size: 13px;
        padding: 3px 10px;
        min-width: 70px;
    }

    @media (max-width: 480px) {
        font-size: 12px;
        padding: 2px 8px;
        min-width: 60px;
    }
`;

export default PriceBadge;

